import React, { Component } from 'react'
import Option from './option'
import { t } from '@billes/translator-client'
import { List, AutoSizer } from 'react-virtualized'

const styles = {
  optionContainer: {
    maxHeight: 300,
    fontSize: 14,
    WebkitBoxShadow: '0 6px 12px rgba(0, 0, 0, .175)',
    boxShadow: '0 6px 12px rgba(0, 0, 0, .175)',
    outline: 'none',
    padding: 0,
    position: 'relative',
    left: 0,
    margin: 0,
    top: 20,
    width: '100%',
    dispaly: 'block',
    zIndex: 30,
    backgroundColor: '#fff',
    borderRadius: 0,
    border: '1px solid #efefef'
  },
  optionsInnerContainer: {
    width: '100%',
    position: 'relative',
    maxHeight: 290,
    top: -4,
    overflowY: 'auto',
    outline: 'none',
    padding: 0,
    listStyleType: 'none'
  }
}

const getValue = option => {
  let value = option.value
  if (option.i18nKey || option.i18nPath) {
    let path =
      option.i18nPath || `bus-shared.aggregation.data.key.${option.i18nKey}`
    value = t(path)
    // the value is not found and we should fall back to value
    if (value.startsWith(path) && option.value) {
      value = option.value
    }
  }
  return value
}

class Options extends Component {
  selectOption(option) {
    const { field, path, signals } = this.props
    if (!field.isMultiple) {
      this.refs.options.blur()
    }
    signals.client.selectOption({
      field: path,
      option: option,
      localeAware: field.localeAware || false
    })
  }

  rowRenderer(options, { key, index, style }) {
    const option = options[index]
    return (
      <Option
        key={key}
        style={style}
        index={option.index}
        filterIndex={index}
        option={option}
        selectOption={() => this.selectOption(option)}
      />
    )
  }

  touchEnd(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  render() {
    const { field, containerFocus } = this.props

    if (!containerFocus || !field.options || !field.options.length) {
      return null
    }

    const iter = field.filteredOptions || field.options

    const options = iter
      .map(option => {
        return {
          ...option,
          value: getValue(option)
        }
      })
      .sort((a, b) => {
        if (a.value && b.value) {
          return a.value.toUpperCase().localeCompare(b.value.toUpperCase())
        }

        return 0
      })

    return (
      <div onTouchEnd={e => this.touchEnd(e)} style={styles.optionContainer}>
        <ul tabIndex={3} ref={'options'} style={styles.optionsInnerContainer}>
          <AutoSizer disableHeight>
            {({ width }) => (
              <List
                width={width}
                height={iter.length > 6 ? 280 : iter.length * 38}
                rowCount={iter.length}
                rowHeight={38}
                rowRenderer={props => {
                  return this.rowRenderer(options, {
                    ...props
                  })
                }}
              />
            )}
          </AutoSizer>
        </ul>
      </div>
    )
  }
}

export default Options



// WEBPACK FOOTER //
// ./src/components/inputs/options.js